import { HTMLAttributes } from 'react'
import { motion } from 'framer-motion'
import { Column } from './Semantic/all'
import { cn } from './ui/utils'

type PageContainerProps = HTMLAttributes<HTMLDivElement> & {
  width?: 'md' | 'lg' | 'xl'
}

export const PageContainer = ({
  className,
  width = 'lg',
  ...props
}: PageContainerProps) => {
  const widthClasses = {
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    xl: 'max-w-[1440px] py-4',
  }

  return (
    <motion.div
      className={cn('flex min-h-0 w-full flex-1 flex-col')}
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <Column
        className={cn(
          'px-6 py-4 mx-auto w-full h-full',
          widthClasses[width],
          className
        )}
        {...props}
      />
    </motion.div>
  )
}
